import { Box } from "@gemini/core"
import { Link, LinkProps } from "@gemini/ui"

import "./LinkNewTab.css"

// Gemini do not want to provide a Link component that is not external but uses target="_blank", so we are hiding the external svg icon
// https://kugawana.slack.com/archives/C048JM75SAC/p1723110131471149?thread_ts=1723108169.783129&cid=C048JM75SAC
export const LinkNewTab = ({
  href,
  children,
  variant,
}: {
  href: string
  children: string
  variant: LinkProps["variant"]
}) => {
  return (
    <Box display="inline" unsafe_className="link-new-tab">
      <Link href={href} variant={variant} isExternal>
        {children}
      </Link>
    </Box>
  )
}
